module.exports = __webpack_public_path__ + "media/images/athletes/68-55b7f7a79f7c1f6123c7a0f3dad4bdb6.png";